import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations, firebaseAction } from "vuexfire";

import { db } from "../main";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    user: {
      loggedIn: false,
      data: null,
    },
    orgs: [],
  },
  getters: {
    user(state) {
      console.log('user', state.user)
      return state.user;
    },
    orgs(state) {
      return state.orgs;
    },
  },
  mutations: {
    ...vuexfireMutations,
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value;
    },
    SET_USER(state, user) {
      state.user = user;
    },
  },
  actions: {
    fetchUser({ commit }, user) {
      commit("SET_LOGGED_IN", user !== null);
      //console.log('user', user);

      if (user) {
        commit("SET_USER", {
          data: user.userObj,
          auth: user.auth,
        });
      } else {
        commit("SET_USER", null);
      }
    },
    bindOrgs: firebaseAction(({ bindFirebaseRef }) => {
      // return the promise returned by `bindFirebaseRef`
      console.log('bindFirebaseRef',bindFirebaseRef)
      return bindFirebaseRef('orgs', db.ref('organisations'))
    }),
  },
});
